import React from 'react';
import BottomNav from '../components/BottomNav';

const BullionInsurance = () => {
  return (
    <div className="page-container">
      <div className="page-wrapper">
        <h1 className="page-title">Gold Bullion Insurance</h1>
        <div className="underline"></div>
        <p className="page-subtitle">Comprehensive Protection for Your Assets</p>
        
        <div className="card">
          <p>
            Protect your gold bullion investments with comprehensive insurance coverage. 
            We offer industry-leading protection with competitive rates.
          </p>
          
          <div className="service-features">
            <div className="feature-item">
              <h3>Full Coverage</h3>
              <p>Complete replacement value protection</p>
            </div>
            <div className="feature-item">
              <h3>Secure Transit</h3>
              <p>Insurance during transportation and delivery</p>
            </div>
            <div className="feature-item">
              <h3>Storage Protection</h3>
              <p>Coverage for vault and secure storage</p>
            </div>
          </div>
        </div>
      </div>
      
      <BottomNav />
    </div>
  );
};

export default BullionInsurance;
